var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 5.75C10.5 5.61193 10.6119 5.5 10.75 5.5H13.25C13.3881 5.5 13.5 5.61193 13.5 5.75V7H10.5V5.75ZM15 5.75V7H17.25C17.6642 7 18 7.33579 18 7.75C18 8.16421 17.6642 8.5 17.25 8.5H6.75C6.33579 8.5 6 8.16421 6 7.75C6 7.33579 6.33579 7 6.75 7H9V5.75C9 4.7835 9.7835 4 10.75 4H13.25C14.2165 4 15 4.7835 15 5.75ZM8.49627 10.6754C8.45506 10.2632 8.08753 9.9625 7.67537 10.0037C7.26321 10.0449 6.9625 10.4125 7.00372 10.8246L7.66367 17.4241C7.75313 18.3187 8.50592 19 9.40498 19H14.595C15.4941 19 16.2469 18.3187 16.3363 17.4241L16.9963 10.8246C17.0375 10.4125 16.7368 10.0449 16.3246 10.0037C15.9125 9.9625 15.5449 10.2632 15.5037 10.6754L14.8438 17.2749C14.831 17.4027 14.7234 17.5 14.595 17.5H9.40498C9.27655 17.5 9.169 17.4027 9.15622 17.2749L8.49627 10.6754Z",
    fill: "#C7CBE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8c7151b7f1b324ccfa6a7ef8811ca5ef.svg";
export { ForwardRef as ReactComponent };